<div class="z-logo">
    <template v-if="isIndex">
        <img :src="buildSrc" class="z-logo__img">
    </template>
    <template v-else>
        <a :href="siteDir" class="z-logo__link" :title="title">
            <img :src="buildSrc" class="z-logo__img">
        </a>
    </template>
</div>